import React, { Fragment } from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function Slide4() {
  const blocks = [{
    title: 'Hook',
    sub: 'Curiosity entry',
    color: 'bg-gray-100'
  }, {
    title: 'Teaser',
    sub: 'Quick interaction',
    color: 'bg-gray-200'
  }, {
    title: 'Trailer',
    sub: 'Core journey',
    color: 'bg-red-100'
  }, {
    title: 'Talk',
    sub: 'Deep dive',
    color: 'bg-red-300'
  }, {
    title: 'Tail',
    sub: 'Reinforcement',
    color: 'bg-roche-red text-white'
  }];
  return <div className="slide-content" data-id="element-87">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6
    }} data-id="element-88">
        <h1 className="slide-headline text-4xl" data-id="element-89">
          One asset <span className="text-roche-red mx-2" data-id="element-90">→</span>
          multiple campaigns <span className="text-roche-red mx-2" data-id="element-91">→</span>
          continuous learning
        </h1>
      </motion.div>

      <div className="flex-1 flex items-center justify-center w-full mt-12" data-id="element-92">
        <div className="flex items-center w-full justify-between relative" data-id="element-93">
          {/* Connecting Line */}
          <div className="absolute top-1/2 left-0 right-0 h-1 bg-gray-100 -translate-y-1/2 -z-10" data-id="element-94">
            <motion.div className="h-full bg-gradient-to-r from-gray-200 via-red-300 to-roche-red" initial={{
            width: '0%'
          }} animate={{
            width: '100%'
          }} transition={{
            duration: 2,
            ease: 'easeInOut',
            delay: 0.5
          }} data-id="element-95" />
          </div>

          {blocks.map((block, index) => <Fragment key={index} data-id="element-96">
              <motion.div className="relative flex flex-col items-center w-48" initial={{
            opacity: 0,
            y: 30
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: 0.5 + index * 0.3
          }} data-id="element-97">
                {/* Top colored indicator */}
                <div className={`w-full h-2 rounded-t-lg ${block.color} mb-0`} data-id="element-98" />

                {/* Card Body */}
                <div className="bg-white w-full p-6 rounded-b-lg shadow-[0_4px_20px_rgb(0,0,0,0.06)] border border-gray-100 border-t-0 flex flex-col items-center text-center h-32 justify-center" data-id="element-99">
                  <h3 className={`text-xl font-bold mb-2 ${index === 4 ? 'text-roche-red' : 'text-text-main'}`} data-id="element-100">
                    {block.title}
                  </h3>
                  <p className="text-sm text-text-muted leading-tight" data-id="element-101">
                    {block.sub}
                  </p>
                </div>

                {/* Node on the line */}
                <div className="absolute top-1/2 -translate-y-1/2 w-4 h-4 rounded-full bg-white border-2 border-roche-red shadow-sm z-10" data-id="element-102" />
              </motion.div>

              {/* Arrow between blocks (except last) */}
              {index < blocks.length - 1 && <motion.div className="z-10 bg-white rounded-full p-1" initial={{
            opacity: 0,
            scale: 0
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.3,
            delay: 0.7 + index * 0.3
          }} data-id="element-103">
                  <ArrowRight className="w-5 h-5 text-text-muted opacity-50" data-id="element-104" />
                </motion.div>}
            </Fragment>)}
        </div>
      </div>

      <motion.div className="slide-punchline text-center w-full" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 0.6,
      delay: 2.5
    }} data-id="element-105">
        Same content. Multiple touchpoints.
      </motion.div>
    </div>;
}